import { Loan } from '@treasury/domain/loans/loan.entity';
import { TmBaseComponent } from '@treasury/presentation';
import { css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import './loan-payment-editable';

export const tagName = 'loan-create-step';
@customElement(tagName)
export class LoanCreateStep extends TmBaseComponent {
    @property({ type: Object })
    public loan = new Loan();

    @state()
    private validLoan = false;

    protected render() {
        return html` <loan-payment-editable
                .loan=${this.loan}
                @update=${(e: CustomEvent) => {
                    this.loan = e.detail;
                    this.checkLoanValidity();
                }}
            ></loan-payment-editable>

            <tm-footer
                .buttonConfig=${[
                    {
                        text: 'Review',
                        disabled: !this.validLoan,
                        onClick: () => {
                            this.dispatchEvent(new CustomEvent('review', { detail: this.loan }));
                        },
                    },
                ]}
            ></tm-footer>`;
    }

    private checkLoanValidity() {
        this.validLoan =
            !!this.loan.fromAccount.id &&
            !!this.loan.toAccount.id &&
            !!this.loan.paymentOptionType &&
            this.loan.amount > 0 &&
            !!this.loan.transferDate;
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: block;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: LoanCreateStep;
    }
}
